import { TierLicensesResponse } from "./LicenseService";
import { store } from "store";

class TierLicenseService {
    public fetchTierLicenses(tier: string): string[] {
        const tierLicenses = store.getState().licensesReducer.tierLicenses;
        const tierData = tierLicenses.tierLicenses.find((t) => t.tier === tier);
        if (!tierData) {
            return [];
        }
        return [...tierData.commonLicenses, ...tierData.features, ...tierData.addOns];
    }

    public fetchTierAddOns(tier: string): string[] {
        const tierLicenses = store.getState().licensesReducer.tierLicenses;
        const tierData = tierLicenses.tierLicenses.find((t) => t.tier === tier);
        if (!tierData) {
            return [];
        }
        return tierData.addOns || [];
    }

    public fetchTierMigratedToCommonLicenses(tier: string): string[] {
        const tierLicenses = store.getState().licensesReducer.tierLicenses;
        const tierData = tierLicenses.tierLicenses.find((t) => t.tier === tier);
        if (!tierData) {
            return [];
        }
        return tierData.migratedToCommonLicenses || [];
    }

    public fetchAllTierLicenses(): TierLicensesResponse {
        return store.getState().licensesReducer.tierLicenses;
    }
}

export const tierLicenseService = new TierLicenseService();
